import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UIState {
  gameLoading: boolean;
}

const initialState: UIState = {
  gameLoading: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setGameLoading: (state, action: PayloadAction<boolean>) => {
      state.gameLoading = action.payload;
    },
  },
});

export const { setGameLoading } = uiSlice.actions;
export default uiSlice.reducer;
